import React, { Suspense, lazy } from 'react'

import { Route, Routes, Outlet } from 'react-router-dom'

// Auth Route
import AuthInit from './Core/Auth/AuthInit'
import PrivateRoute from './Core/Utils/PrivateRoute'

import {  } from 'react-bootstrap';

import Loader from './Helpers/Loader'

import './App.css';

import DefaultLayout from './Layouts/DefaultLayout'

import {Helmet} from "react-helmet";

import logo from './Images/krayr.svg'
import AppleIcon from './Assets/apple-touch-icon.png'
import Icon32 from './Assets/favicon-32x32.png'
import Icon16 from './Assets/favicon-16x16.png'
import SiteManifest from './Assets/site.webmanifest'
import safariPinnedTab from './Assets/safari-pinned-tab.svg'
import ContactUs from './Pages/ContactUs';


const Home           = ( lazy(() => import("./Pages/Home")) );
const IT             = ( lazy(() => import("./Pages/It")) );
// const ContactUs      = ( lazy(() => import("./Pages/ContactUs")) );
const Recruitment    = ( lazy(() => import("./Pages/Recruitment")) );
const About          = ( lazy(() => import("./Pages/About")) );
const CareerInPoland = ( lazy(() => import("./Pages/CareerInPoland")) );
const PrivacyPolicy = ( lazy(() => import("./Pages/PrivacyPolicy")) );
const TermsOfServices = ( lazy(() => import("./Pages/TermsOfServices")) );

const Login          = ( lazy(() => import("./Pages/Auth/Login")) );
const ResetPassword          = ( lazy(() => import("./Pages/Auth/ResetPassword")) );

// Auth Pages
const Profile         = (lazy(() => import('./Pages/Auth/Profile/Index')));
const Dashboard       = (lazy(() => import('./Pages/Auth/Dashboard')));
const Submissions      = (lazy(() => import('./Pages/Auth/Submission/Index')));
const SubmissionShow      = (lazy(() => import('./Pages/Auth/Submission/Show')));
// const LessonsCategories  = (lazy(() => import('./Pages/LessonsCategories/Index')));
const CategoryLessons  = (lazy(() => import('./Pages/Lessons/Index')));
const LessonDetails   = (lazy(() => import('./Pages/Lessons/Show')));



const App = () => {

  return (    
    <div className="">
      <Helmet>
        <meta charSet='utf-8' />
        <title>Krayr</title>
        <meta name="description" content="Krayr" />
        <link rel="apple-touch-icon" sizes="180x180" href={AppleIcon} />
        <link rel="icon" type="image/png" sizes="32x32" href={Icon32} />
        <link rel="icon" type="image/png" sizes="16x16" href={Icon16}/>
        <link rel="manifest" href={SiteManifest} />
        <link rel="mask-icon" href={safariPinnedTab} color="red" />
        <meta name="msapplication-TileColor" content="#da532c" />
        <meta name="theme-color" content="#ffffff" />

      </Helmet>
      <AuthInit>
        <Outlet />
        <Suspense fallback={
          <Loader />
        }>
          <Routes>

              {/* Visitor Routes */}
              <Route path='/' element={<DefaultLayout><Home/></DefaultLayout>}/>
              <Route path='/careerinpoland' element={<DefaultLayout><CareerInPoland/></DefaultLayout>}/>
              <Route path='/about-us' element={<DefaultLayout><About/></DefaultLayout>}/> 
              <Route path='/contact' element={<DefaultLayout><ContactUs/></DefaultLayout>}/> 
              <Route path='/academy' element={<DefaultLayout><IT/></DefaultLayout>}/>
              <Route path='/recruitment' element={<DefaultLayout><Recruitment/></DefaultLayout>}/>
              <Route path='/courses/:categoryId' element={<DefaultLayout><CategoryLessons/></DefaultLayout>}/>
              <Route path='/courses/:categoryId/:lessonId' element={<DefaultLayout><LessonDetails/></DefaultLayout>}/>
              <Route path='/privacy-policy' element={<DefaultLayout><PrivacyPolicy/></DefaultLayout>}/>
              <Route path='/terms-of-services' element={<DefaultLayout><TermsOfServices/></DefaultLayout>}/>
              
              <Route path="/login" element={<Login/>} /> 
              <Route path="/reset/:token" element={<ResetPassword/>} /> 


              {/* Auth Routes */}
              <Route path="/dashboard" element={<PrivateRoute component={Dashboard}/>} />  
              <Route path="/profile" element={<PrivateRoute component={Profile}/>} />  
              <Route path='/submissions' element={<PrivateRoute component={Submissions} />}/>
              <Route path='/submissions/:submissionID' element={<PrivateRoute component={SubmissionShow} />}/>
          </Routes>
         
        </Suspense>   

      </AuthInit>
    </div>
  ) 
}

export default App;
